const installationInstructions = {
  intro: {
    currentStep: 'intro',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/device-models/CW051/camera_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.camera.powerDevice.title',
    secondaryTx: 'categories.camera.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      lastStep: 'intro',
      titleTx: 'categories.camera.stepsToReset',
    },
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    prevStep: 'intro',
    prevStepName: 'instructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/device-models/CW051/camera_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.camera.confirmPairingMode.title',
    secondaryTx: 'categories.camera.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.readyToPair',
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      lastStep: 'letsGetStarted',
      titleTx: 'categories.camera.stepsToReset',
    },
  },
  pairingModeReset: {
    headerIcon: 'closeBlack',
    prevStep: 'intro',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.camera.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/device-models/CW051/reset_step1.png'),
          primaryTx: 'categories.camera.resetDevice.step1.title',
          secondaryTx: 'categories.camera.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/device-models/CW051/reset_step2.png'),
          primaryTx: 'categories.camera.resetDevice.step2.title',
          secondaryTx: 'categories.camera.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/device-models/CW051/reset_step3.png'),
          primaryTx: 'categories.camera.resetDevice.step3.title',
          secondaryTx: 'categories.camera.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
